export default __webpack_public_path__ + "static/media/logoHorizontal-6pt.2a4f1e31.svg";